import styled, { css } from 'styled-components';
import { SectionHeading, Paragraph } from '../../global/typography';

export const StyledSection = styled.section<{ $imageUrl: string }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 50px;
    padding: 3.12rem 0;

    &::before {
        content: '';
        position: absolute;
        width: 100vw;
        height: 100%;
        top: 0;
        left: 50%;
        margin-left: -50vw;
        background-image: url(${props => props.$imageUrl});
        background-size: cover;
        background-position: center center;
        z-index: -1;

        @media (max-width: 979px) {
            display: none;
            padding: 0;
        }
    }

    @media (max-width: 780px) {
        padding-top: 0px;
    }

    @media (max-width: 979px) {
        flex-direction: column;
        margin: 0 -15px;
    }
`;

export const StyledContainer = styled.div<{ $flex: 'row' | 'column'; $side: 'left' | 'right' }>`
    display: flex;
    background-color: ${props => props.theme.colors.primary};
    flex: 0 0 50%;
    max-width: 50%;
    padding: 50px;

    ${props =>
        props.$side === 'left' &&
        css`
            margin-right: auto;
        `}
    ${props =>
        props.$side === 'right' &&
        css`
            margin-left: auto;
        `}

    ${props =>
        props.$flex === 'row' &&
        css`
            flex-direction: row;

            @media (max-width: 979px) {
                flex-direction: column;
            }
        `}

    ${props =>
        props.$flex === 'column' &&
        css`
            flex-direction: column;
        `}

  @media (max-width: 979px) {
        flex: 0 0 100%;
        max-width: 100%;
        padding: 30px;
    }
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: black;
`;

export const StyledHeading = styled(SectionHeading)`
    color: white;
    text-align: left;
    margin-bottom: 1.25rem;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 1rem 0;
`;

export const StyledSubtitle = styled.h3`
    font-size: 1.625rem;
    font-style: normal;
    font-weight: 600;
    line-height: 2.125rem;
    margin-bottom: 1.25rem;

    @media (max-width: 979px) {
        font-size: 1.5rem;
    }
`;

export const StyledParagraph = styled(Paragraph)``;

export const RightsideContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex: 0 0 calc(25% - 50px / 2);
    max-width: calc(25% - 50px / 2);

    @media (max-width: 979px) {
        flex: 0 0 100%;
        max-width: 100%;
    }
`;

export const LogotypesContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
